import { Flex } from "@chakra-ui/react";
import { useField } from "formik";
import {
  FormikSwitchInput,
  FormikSwitchInputProps,
} from "src/components/Inputs/FormikSwitchInput";

type Props<FieldType> = Omit<FormikSwitchInputProps<FieldType>, "direction"> & {
  children: React.ReactNode;
  showContent: (value: FieldType) => boolean;
};

export function FormikSwitchableContent<FieldType>({
  children,
  name,
  showContent,
  variant = "switch",
  ...formikSwitchInputProps
}: Props<FieldType>) {
  const [field] = useField<FieldType>(name);
  return (
    <Flex direction="column">
      <FormikSwitchInput<FieldType>
        name={name}
        variant={variant}
        {...formikSwitchInputProps}
        direction="row"
      />
      <Flex
        direction="column"
        flex={1}
        marginLeft={variant === "switch" ? 12 : 8}
        gap={2}
      >
        {showContent(field.value) ? children : null}
      </Flex>
    </Flex>
  );
}
